import { configLoaded, getConfigValue } from '@pressreader/config';

import { IIdentity } from 'integration/adapter';
import identityFactory from 'integration/identity.factory';

let promise: Promise<Partial<IIdentity>>;

export function loadExternalAuthenticationProvider() {
    if (!promise) {
        promise = (async () => {
            await configLoaded();
            const providerName = getConfigValue<string>('Authentication.ExternalAuthenticationProvider', '');
            if (providerName) {
                const provider = identityFactory.create(providerName);
                await provider.load();
                return provider;
            }
            return null;
        })();
    }
    return promise;
}
